var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-section',{attrs:{"title":"Communications"}},[_c('trombi',{attrs:{"list":_vm.congresses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }